<template>
    <div id="bookmark-panel"
         :style="data.stylePpanel"
    >
        <div class="heading"><span>{{ i18n.t("label_bookmarks") }}</span></div>
        <div class="action-menubar">
            <div class="left">
                <a id="btn-add-to-bookmark"
                   class="btn-operation"
                   href="#"
                   :title="i18n.t('tooltip_add_to_bookmarks')"
                   @click.prevent="addBookmark"
                >
                </a>
            </div>
            <div class="right">
                <a id="btn-thumbnail-view"
                   class="btn-operation"
                   href="#"
                   :class="data.classBtnThumbnailView"
                   :title="i18n.t('tooltip_thumbnail_view')"
                   @click.prevent="bookmarkState.viewMode = 'thumbnail'"
                >
                </a>
                <a id="btn-list-view"
                   class="btn-operation"
                   href="#"
                   :class="data.classBtnListView"
                   :title="i18n.t('tooltip_list_view')"
                   @click.prevent="bookmarkState.viewMode = 'list'"
                >
                </a>
                <a id="btn-edit"
                   href="#"
                   v-show="hasBookmark"
                   @click.prevent="toggleEdit"
                   :title="data.btnEditLabel"
                >
                    <span> {{ data.btnEditLabel }} </span>
                </a>
            </div>
        </div>
        <div id="bookmark-list-container"
             class="full-size"
        >
            <thumbnail-view v-show="bookmarkState.viewMode === 'thumbnail'"></thumbnail-view>
            <list-view v-show="bookmarkState.viewMode === 'list'"></list-view>
        </div>
    </div>
    <div id="mask"
         @click="toggleBookmark"
    >
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUnmounted, onUpdated, watchEffect, watch, computed, nextTick, inject}  from "vue";
    import config from "@/config/config.json";
    import cssvar from '@/scss/_variables.scss';
    import ListView from "@/views/reader/bookmark/ListView";
    import ThumbnailView from "@/views/reader/bookmark/ThumbnailView";
    import {useBookmark}  from "@/modules/reader/bookmark/bookmark";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";

    const headerHeight = parseInt(cssvar.headerHeight)
    const footerHeight = parseInt(cssvar.footerHeight)
    const bookmarkPanelVerticalMargin = parseInt(cssvar.bookmarkPanelVerticalMargin)


    export default {
        components: {
            ListView,
            ThumbnailView
        },
        setup(props, context) {

            const {toggleBookmark, addBookmark} = useBookmark();
            const {bookmarkState, hasBookmark, toggleEdit} = useBookmark();
            const i18n = inject('i18n');

            const data = reactive({
                pPanelHeight:0,
                stylePpanel:computed(()=>{
                    return {
                        top:`${headerHeight + bookmarkPanelVerticalMargin}px`,
                        height:`${data.pPanelHeight}px`
                    }
                }),
                viewMode:"thumbnail",
                btnEditLabel: computed(()=>{
                    if (bookmarkState.isEditing) {
                        if (bookmarkState.hasDeletion) {
                            return i18n.t("label_done");
                        } else {
                            return i18n.t("label_cancel");
                        }
                    } else {
                        return i18n.t("label_edit");
                    }
                }),
                classBtnThumbnailView:computed(()=>{
                    if (bookmarkState.viewMode === "thumbnail") {
                        return ["active-view-mode", "thumbnail-active"]
                    }

                }),
                classBtnListView:computed(()=> {
                    if (bookmarkState.viewMode === "list") {
                        return ["active-view-mode", "list-active"]
                    }
                })
            })

            let startScrollPageY = {}
            let scrollTop = {};

            startScrollPageY["thumbnail"] = 0;
            startScrollPageY["list"] = 0;

            scrollTop["thumbnail"] = 0;
            scrollTop["list"] = 0;


            const windowOnResized = (e)=>{
                let scale = (isTouchDevice()) ? window.visualViewport.scale : 1;
                data.pPanelHeight = (window.innerHeight- headerHeight - footerHeight - 2 * bookmarkPanelVerticalMargin) * scale;
            }


            const updateContainerScrollPos  = ()=>{
                document.getElementById("bookmark-list-container").scrollTop = bookmarkState.containerScrollTop[bookmarkState.viewMode]
            }

            onMounted(()=>{

                if (!isTouchDevice()) {
                    window.addEventListener("resize", (e) => {
                        windowOnResized();
                    })
                }

                windowOnResized();

                nextTick(()=>{
                    document.querySelector("#bookmark-list-container").addEventListener("scroll", (e)=> {
                        bookmarkState.containerScrollTop[bookmarkState.viewMode] = e.currentTarget.scrollTop;
                    });
                })
            });

            onUnmounted(()=>{
            })

            watchEffect(()=>{
                if (!bookmarkState.isShow) {
                    bookmarkState.isEditing = false;
                } else {
                }

                if (bookmarkState.viewMode) {
                    nextTick(() => {
                        if (document.getElementById("bookmark-list-container")) {
                            setTimeout(()=> {
                               updateContainerScrollPos();
                            }, isTouchDevice() ? 100: 0);
                        }
                    });
                }

            })

            return {
                i18n,
                data,
                bookmarkState,
                hasBookmark,
                toggleBookmark,
                addBookmark,
                toggleEdit,
                config
            }
        }

    }

</script>

<style scoped lang="scss">

    $operation-btn-border-radius:6px;

    #bookmark-panel {
        width:400px;
        position: fixed;
        left:0;
        z-index: $zindex-bookmarkpanel;
        border-radius:0 8px 8px 0;
        border:2px solid $border-color-light;
        box-sizing: border-box;
        overflow:hidden;
        background:#fff;
        box-shadow: 0 7px 7px #666;
        @include transition(transform,.3s);
    }

    .heading {
        background: $color-primary;
        color:$color-primary-deepest;
        font-size:18px;
        font-weight:400;
        padding:10px;
        width:100%;
        display:flex;
        color:#fff;
        align-items: center;
    }

    .action-menubar {
        background: $color-primary-light;
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: flex-end;
        padding: 6px 4px;
        box-sizing: border-box;

        .left {
            margin-right:auto;
        }

        > div {
            display:flex;
        }

        a {
            display: flex;
            padding:7px 9px;
            border-radius: $operation-btn-border-radius;
            background: linear-gradient(180deg,#fff 1%,#f3f3f3 81%);
            align-items:center;
            justify-content: center;
            @include transition(all, 0.2s);

            &:hover, {
                background-color:$color-primary-bright !important;
            }

            &.active-view-mode{
                background-color:$color-primary !important;
                border-color:$color-primary !important;
            }
        }


        #btn-add-to-bookmark {
            background:url("~images/btn_add_bookmark.svg") center center no-repeat;
            &:hover {
                background:url("~images/btn_add_bookmark_over.svg") center center no-repeat;
                background-size:14px 12px !important;
            }
        }

        #btn-thumbnail-view {
            border-radius:$operation-btn-border-radius 0  0 $operation-btn-border-radius !important;
            background:url("~images/btn_bookmark_thumb_mode.svg") center center no-repeat;
            &:hover {
                background:url("~images/btn_bookmark_thumb_mode_over.svg") center center no-repeat;
                background-size:14px 12px !important;
            }
        }

        .thumbnail-active {
            background:url("~images/btn_bookmark_thumb_mode_over.svg") center center no-repeat !important;
        }

        .list-active {
            background:url("~images/btn_bookmark_list_mode_over.svg") center center no-repeat !important;
        }

        #btn-list-view {
            border-radius:0  $operation-btn-border-radius $operation-btn-border-radius 0 !important;
            background:url("~images/btn_bookmark_list_mode.svg") center center no-repeat;
            &:hover {
                background:url("~images/btn_bookmark_list_mode_over.svg") center center no-repeat;
                background-size:14px 12px !important;
            }
        }

        .btn-operation {
            width:14px;
            height:12px;
            background-color:$grey-lighter !important;
            border:1px solid $border-color-light;
            background-size:14px 12px  !important;
        }


        #btn-edit {
            width: 36px;
            padding:8px 10px;
            display: flex;
            align-items: center;
            border: 1px solid #ccc;
            border-radius:$operation-btn-border-radius;
            margin:0 0 0 6px;
            color:$text-color-primary;
            @include transition(all, 0.2s);

            &:hover {
                color:#fff;
                background:$color-primary-brighter;
            }
        }

    }

    #bookmark-list-container {
        overflow-y: auto;
        touch-action:pan-y;
        overscroll-behavior: contain;
    }

    #mask {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
        position: fixed;
        left: 0;
        top: 0;
        z-index:$zindex-bookmarkpanel-mask;
    }


    //TODO: clean mixins , don't repeat with ppanel...

    @mixin set-mobile-width() {

        #ppanel {
            width:70%;
        }
    }

    @include responsive(mobile-tiny) {
        @include set-mobile-width;
    }

    @include responsive(mobile) {
        @include set-mobile-width;
    }


    @include responsive(mobile-large) {
        @include set-mobile-width;
    }

    @include responsive(mobile-mega) {
        @include set-mobile-width;
    }

    :deep(.bookmark-listing) {
        margin: 0 0 80px 0;
    }

    :deep(.item) {
        color:$text-color-primary;
    }


</style>